import script from "./Commentary.vue?vue&type=script&setup=true&lang=js"
export * from "./Commentary.vue?vue&type=script&setup=true&lang=js"

export default script